module.exports = __webpack_public_path__ + "img/Download.2c2cb7ec.svg";